/* eslint-disable jsx-a11y/anchor-is-valid */
import Icon from '@components/Icon';
import { useFavorites } from '@context/Favorites';
import { FC } from 'react';
import { Link } from 'react-router-dom';

/**
 * The aside "Favorites" panel — a user's saved page shortcuts (public.shortcut_link).
 * Add a page from its title bar (the ★ next to the page title); remove it here.
 */
const Dropdown2: FC = () => {
  const { favorites, removeFavorite, loading } = useFavorites();

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-350px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center fs-6 text-dark fw-bolder px-3 py-4'>
          <Icon icon='star' color='warning' size={22} />
          &nbsp;Favorites
        </div>
      </div>

      <div className='separator mb-2 opacity-75'></div>

      <div className='px-2 pb-3' style={{ maxHeight: 340, overflowY: 'auto', overflowX: 'hidden' }}>
        {favorites.length ? (
          favorites.map((f) => (
            <div
              key={f.id}
              className='d-flex align-items-center justify-content-between rounded px-3 py-2 bg-hover-light'
            >
              <Link
                to={f.path}
                className='d-flex align-items-center text-gray-800 text-hover-primary flex-grow-1 text-truncate me-2'
                title={f.name}
              >
                <Icon
                  icon={f.icon || 'star'}
                  size={20}
                  variants='outlined'
                  className='text-warning me-3 flex-shrink-0'
                />
                <span className='text-truncate'>{f.name}</span>
              </Link>
              <span
                role='button'
                className='btn btn-icon btn-sm btn-active-light-danger w-25px h-25px flex-shrink-0'
                title='Remove from favorites'
                onClick={() => removeFavorite(f.id)}
              >
                <Icon icon='close' size={16} />
              </span>
            </div>
          ))
        ) : (
          <div className='text-muted text-center px-4 py-8 fs-7'>
            {loading
              ? 'Loading…'
              : 'No favorites yet. Open any page and click the ★ next to its title to add it here.'}
          </div>
        )}
      </div>
    </div>
  );
};

export { Dropdown2 };
